import { render, staticRenderFns } from "./layout-blank.vue?vue&type=template&id=1ee21350"
import script from "./layout-blank.vue?vue&type=script&lang=js"
export * from "./layout-blank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports